define([
    'experiment'
], function (experiment) {
    'use strict';
    const interactiveElements = [
        'a[href]',
        'area[href]',
        'input:not([disabled])',
        'select:not([disabled])',
        'textarea:not([disabled])',
        'button:not([disabled])',
        'details',
        'summary',
        'iframe',
        'object',
        'embed',
        '[contenteditable]',
        '[tabindex]'
    ];
    const headerContent = 'SITE_HEADERinlineContent-gridContainer';
    const toggleId = 'MENU_AS_CONTAINER_TOGGLE';
    class InertContent {
        constructor() {
            this.elements = new Map();
            this.containers = new Map();
        }
        saveAttr(list, map, attr, newValue) {
            list.forEach(item => {
                const value = item.getAttribute(attr);
                map.set(item, {[attr]: value});
                item.setAttribute(attr, newValue);
            });
        }
        recoverAttr(map, attr) {
            map.forEach((attrs, item) => {
                const value = attrs[attr];
                if (value !== null) {
                    item.setAttribute(attr, value);
                } else {
                    item.removeAttribute(attr);
                }
            });
            map.clear();
        }
        makeContentInert(document) {
            const isOpen = experiment.isOpen('headerMenuInertContent', undefined);
            if (!isOpen) {
                return;
            }
            let els = interactiveElements.map(
                el => `main ${el}, footer ${el}, #${headerContent} ${el}`
            ).join(',');
            els = [...document.querySelectorAll(els)].filter(el => el.id !== toggleId);
            const containers = document.querySelectorAll('main, footer');
            this.saveAttr(els, this.elements, 'tabIndex', -1);
            this.saveAttr(containers, this.containers, 'aria-hidden', true);
        }
        makeContentInteractive() {
            this.recoverAttr(this.elements, 'tabIndex');
            this.recoverAttr(this.containers, 'aria-hidden');
        }
    }
    return InertContent;
});
